import React from 'react'
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
 class Education extends React.Component{ 
     constructor(props){
         super(props);
         this.validator = new SimpleReactValidator();
     }    
     submitForm =(event)=> { 
        event.preventDefault(); 
        if (this.validator.allValid()) { 
            this.props.history.push(`/eligibility/${this.props.match.params.contary}/step3`);
       } else {
         this.validator.showMessages();
         this.forceUpdate();
       }
    }
     render(){
         return(
            <div>
                <div className="progressbar-data pb-3 pt-4">
                    <div className="progressbar-container">
                        <ul className="progressbar">
                        <li className="active">
                            <div className="pg-text">Personal</div>
                            <div className="pg-text">Details</div>
                        </li>
                        <li className="active">
                            <div className="pg-text active">Education</div>
                            <div className="pg-text active">Details</div>
                        </li>
                        <li>
                            <div className="pg-text">Documents upload</div>
                            <div className="pg-text">& Declaration</div>
                        </li>
                        <li>
                            <div className="pg-text">Fees &</div>
                            <div className="pg-text">Charges</div>
                        </li>
                        </ul>
                    </div>    
                </div> 
                <form>
                     <div className="form-container">
                            <h4 className="heading4 text-color2 mb-3 pl-3">Education</h4>
                            {
                               this.props.person.education.map((education, index) => {                                  
                                  return    <div className="form-wrap mc-border mb-4" key={index}>                                     
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label htmlFor="title" className="form-label1">Degree Title</label>                                                            
                                                            <input id="title" value={education.title} className="form-control form-input1" type="text"  index={index} name="title" onChange={(event)=>this.props.onSetEducation(event)}  placeholder="Title" />
                                                            {this.validator.message('Degree Title  ', education.title, 'required|alpha_space', { className: 'text-danger' })}
                                                        </div>
                                                    </div>  
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label htmlFor="institute" className="form-label1">Institute</label>
                                                            <input id="institute" value={education.institute} className="form-control form-input1" type="text" index={index} name="institute" onChange={(event)=>this.props.onSetEducation(event)}  placeholder="Name" />
                                                            {this.validator.message('Institute', education.title, 'required|alpha_space', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="attended_from" className="form-label1">Date Attended (from)</label>
                                                            <input id="attended_from" value={education.attended_from} className="form-control form-input1" type="date" index={index} name="attended_from"  onChange={(event)=>this.props.onSetEducation(event)}   />
                                                            {this.validator.message('Date', education.attended_from, 'required', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                    
                                                    {
                                                        education.attended_from &&
                                                        (
                                                        <div className="col-lg-4">
                                                            <div className="form-group">
                                                                <label htmlFor={education.attended_from} className="form-label1">Date Attended (to)</label>
                                                                <input id="attended_to" min={education.attended_from} value={education.attended_to} className="form-control form-input1" type="date" index={index} name="attended_to" onChange={(event)=>this.props.onSetEducation(event)}   />
                                                                {this.validator.message('Date', education.attended_to, 'required', { className: 'text-danger' })}
                                                                
                                                            </div>
                                                        </div>)
                                                    } 
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="percentage" className="form-label1">Marks %</label>
                                                            <input id="percentage" value={education.percentage} className="form-control form-input1" type="text" index={index} name="percentage" placeholder="0.00" onChange={(event)=>this.props.onSetEducation(event)}   />
                                                            {this.validator.message('Marks', education.percentage, 'required|numeric', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                               })
                            }
                            <div>
                                <button className="btn fw-sb" type="button" onClick={this.props.onAddEducation}>+ Add another qualification</button>
                            </div>            
                    </div>                      
                        
                    <div className="form-group text-right">
                        <Link to={`/eligibility/${this.props.match.params.contary}/step1`} type="button" className="btn btn-back mr-2 bg-white">Back</Link>
                        <button typr="button"  type="button" className="btn btn-apply" onClick={this.submitForm}>Continue</button>
                    </div>
                </form>
            </div>
         )
     }
 }
 
 const mapStateToProps = state => {
    return {
        person: state.person
    };
};
 
const mapDispatchToProps = dispatch => {   
    return {
        onSetEducation: (event) => dispatch({type: 'SET_EDUCATION', event: event}),
        onAddEducation: () => dispatch({type: 'ADD_EDUCATION'})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Education));